module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "calendrier_activite",
      "toolbar": "",
      "footer": ""
    }
  }, [(_vm.proposeRight) ? _c('v-navigation-drawer', {
    staticClass: "pink darken-2",
    attrs: {
      "persistent": "",
      "light": "",
      "right": "",
      "enable-resize-watcher": "",
      "overflow": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "droite"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "toolbar"
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "pink darken-2"
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("© Le Sénat 2019")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ddf5b27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 372
// module chunks = 1